var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38459 2H7.4528C3.72991 2 2 4.17544 2 8.22847V15.7715C2 19.6361 4.36352 22 8.22905 22H15.7533C19.6114 22 21.9735 19.6347 21.9735 15.7715L22 10.9706C22 6.92273 20.3106 4.94127 16.5296 4.94127H13.7951C13.3298 4.94034 12.8906 4.72042 12.6098 4.34714L11.7281 3.17286C11.1753 2.43479 10.3068 2 9.38459 2ZM7.4528 3.45147H9.38459C9.85058 3.45147 10.2894 3.67116 10.569 4.04444L11.4516 5.21988C12.0059 5.95693 12.8727 6.3909 13.7936 6.39273L16.5296 6.39274C19.4547 6.39274 20.5505 7.67793 20.5505 10.9666L20.524 15.7675C20.524 18.8331 18.8109 20.5485 15.7533 20.5485H8.22905C5.1637 20.5485 3.44955 18.8341 3.44955 15.7715V8.22847C3.44955 4.91372 4.61233 3.45147 7.4528 3.45147ZM17.3425 14.5438C17.3425 14.143 17.0181 13.8181 16.6178 13.8181H7.34695L7.24861 13.8247C6.89484 13.8727 6.62218 14.1764 6.62218 14.5438C6.62218 14.9446 6.94667 15.2695 7.34695 15.2695H16.6178L16.7161 15.2629C17.0699 15.2149 17.3425 14.9112 17.3425 14.5438Z",
    fill: "#200E32"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFolder);
export default __webpack_public_path__ + "static/media/folder.73355378a9ede74b1abf7ec55250209f.svg";
export { ForwardRef as ReactComponent };